import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import PropTypes from 'prop-types';

import Login from '../NewHome/components/Login';
import OtpModal from '../NewHome/components/OtpModal';
import SignUp from '../NewHome/components/SignUp';
import SuccessModal from '../NewHome/components/SuccessModal';
import WaitList from '../NewHome/components/WaitList';
import Header from './Header';
import FAQSection from '../BodyParts/FAQSection';
// import HowFreeTrailWorks from '../Payment/components/HowFreeTrialWorks';
import JenHealthChallenge from './JenHealthChallenge';
import MeetDocJen from './MeetDocJen';
import Next30Days from './Next30Days';
import Modal from '../NewHome/components/Modal';
import Label from './Label';
// import WinPrizes from './WinPrizes';
import JoinFullBodyImpactPlan from './JoinFullBodyImpactPlan';
import VideoSection from './VideoSection';
import Testimonial from './Testimonials';
import Features from './Features';

import {
  LOCAL_STORAGE_CONSTANT,
  MODAL_TYPE,
  GRATEFUL_FOR_BODY_NEXT_30_DAYS,
  GRATEFUL_FOR_BODY_FAQS,
  TEXT_CONSTANT,
} from '../../constants/app';
import { removeItem } from '../../utils/cache';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';
import { Wrapper } from '../NewHome';
import { getDisplayType, logOutput, scrollToTop } from '../../utils/helpers';
import useWindowWidth from '../../hooks/useWindowWidth';
import SeoTags from '../../components/SeoComponent';
import {
  getCanonicalLink,
  // lowImpactSnippet,
  SeoTexts,
} from '../../services/SEO';
import { extractJSON } from '../../services/jsonUtil';
import { useCourseDetail } from '../../hooks/useCourseDetail';
import ErrorModal from '../../components/ErrorModal';
import { withFooter } from '../../hoc/withFooter';
// import November1Challenge from './November1Challenge';
// import ExperienceGratefulBodyChallenge from './ExperienceGratefulBodyChallenge';
import JenCalender from './JenCalander';
import { APP_ROUTES } from '../../route';

import './style.css';

const FullBodyLowImpact = ({ history, match }) => {
  const [modalState, setModalState] = useState(null);
  const [countryCode, setCountryCode] = useState('us');
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const {
    challengeError,
    handleCourseRedirection,
    isLoading,
    setChallengeError,
    courseDetail,
  } = useCourseDetail(history, match);
  const endDate = '01/11/2022';
  // const liveNow = new Date(endDate).getTime() - new Date().getTime() < 0;
  const liveNow = false;
  useEffect(() => {
    scrollToTop();
  }, []);

  const handleModalState = modalData => setModalState(modalData);

  const handleModalEvent = modalType => setModalState(modalType);

  useEffect(() => {
    axios
      .get('https://ipapi.co/json/')
      .then(response => {
        const data = response.data;
        setCountryCode(data.country_code.toLowerCase());
      })
      .catch(error => {
        logOutput(error);
      });
  }, []);

  const dialogClassName = (() => {
    switch (modalState) {
      case MODAL_TYPE.SUCCESS:
        return 'success-modal';
      case MODAL_TYPE.WAITLIST:
        return 'survey-modal';
      default:
        return undefined;
    }
  })();

  const handleClose = () => {
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_SESSION);
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS);
    setModalState(false);
  };

  const handleAuthFlow = (buttonTitle, eventType, section) => {
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      button_title: buttonTitle,
      page: '30 Days of Release & Recovery Challenge Page',
      section_title: `${section}`,
    });
    const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    if (user) {
      handleCourseRedirection();
    } else {
      trackEvent(SEGMENT_EVENTS.AUTH_FLOW_INITIATED, {
        page: '30 Days of Release & Recovery Challenge Page',
        section_title: `${section}`,
      });
      handleModalEvent(eventType);
      if (isMobileScreen) {
        scrollToTop();
      }
    }
  };

  const renderModalContent = () => {
    switch (modalState) {
      case MODAL_TYPE.LOGIN:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <Login
              page="30 Days of Release & Recovery Challenge Page"
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
              plan_id={courseDetail?.id}
            />
          </Wrapper>
        );
      case MODAL_TYPE.OTP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <OtpModal
              page="30 Days of Release & Recovery Challenge Page"
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
              plan_id={courseDetail?.id}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SIGNUP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <SignUp
              page="30 Days of Release & Recovery Challenge Page"
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
              plan_id={courseDetail?.id}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SUCCESS:
        return <SuccessModal />;
      case MODAL_TYPE.WAITLIST:
        return <WaitList />;
      default:
        return null;
    }
  };

  const renderPageContent = () => (
    <div className="grateful-for-my-body-challenge-page thirty-day-program">
      <Label onClick={handleAuthFlow} liveNow={liveNow} endDate={endDate} />
      <Header onClick={handleAuthFlow} />
      <JoinFullBodyImpactPlan
        isLoading={isLoading}
        courseDetail={courseDetail}
        onClick={handleAuthFlow}
        liveNow={liveNow}
      />
      <Testimonial />
      <VideoSection onClick={handleAuthFlow} />
      <Features onClick={handleAuthFlow} courseDetail={courseDetail} />
      <Next30Days
        text={TEXT_CONSTANT.WHAT_YOU_GET}
        sections={GRATEFUL_FOR_BODY_NEXT_30_DAYS}
        onClick={handleAuthFlow}
      />
      <JenCalender
        loading={isLoading}
        onClick={handleAuthFlow}
        courseDetail={courseDetail}
      />
      {/* <HowFreeTrailWorks
        hidePlanSelector={true}
        loading={isLoading}
        onClick={() =>
          handleAuthFlow(
            'START MY FREE WEEK',
            'isSignup',
            'How does your free trial work?',
          )
        }
      /> */}
      <JenHealthChallenge onClick={handleAuthFlow} endDate={endDate} />
      <FAQSection
        buttonText={TEXT_CONSTANT.I_AM_READY}
        onClick={handleAuthFlow}
        faqs={GRATEFUL_FOR_BODY_FAQS}
      />
      <MeetDocJen lowBodyImpact={true} />
    </div>
  );

  const renderContentMobile = () => {
    if (modalState) {
      return renderModalContent();
    } else {
      return renderPageContent();
    }
  };

  return (
    <div className={clsx('main', isMobileScreen && modalState && 'h-100')}>
      {isMobileScreen &&
      ![MODAL_TYPE.SUCCESS, MODAL_TYPE.WAITLIST].includes(modalState)
        ? renderContentMobile()
        : renderPageContent()}
      {!isMobileScreen && (
        <Modal
          dialogClassName={dialogClassName}
          show={Boolean(modalState)}
          handleClose={handleClose}
        >
          {renderModalContent()}
        </Modal>
      )}
      <ErrorModal
        handleClose={() => setChallengeError(false)}
        handleCourseRedirection={handleCourseRedirection}
        isLoading={isLoading}
        page="30 Days of Release & Recovery Challenge Page"
        show={challengeError}
      />
      <SeoTags
        title={SeoTexts.GRATEFUL_FOR_MY_BODY_TITLE}
        metaDescription={SeoTexts.GRATEFUL_FOR_MY_BODY_DESCRIPTION}
        canonicalLink={getCanonicalLink(APP_ROUTES.GRATEFUL_FOR_BODY)}
        ogImgUrl={SeoTexts.GRATEFUL_FOR_MY_BODY_OG_IMAGE_URL}
        twitterImgUrl={SeoTexts.GRATEFUL_FOR_MY_BODY_TWITTER_IMAGE_URL}
        // richSnippet={lowImpactSnippet}
      />
    </div>
  );
};

FullBodyLowImpact.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
};

export default withFooter(FullBodyLowImpact);
